import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

import { WarningMessageComponent, WarningMessageType } from '@lib/shared-ui/commons/warning-message/warning-message.component';

export interface UploadErrorDialogData {
  message: string;
  additionalText: string;
}

@Component({
  selector: 'md-upload-error-modal',
  standalone: true,
  imports: [MatIcon, TranslatePipe, MatDialogClose, WarningMessageComponent],
  templateUrl: './upload-error-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadErrorModalComponent {
  protected readonly dialogRef = inject(MatDialogRef);
  protected readonly data: UploadErrorDialogData = inject(MAT_DIALOG_DATA);

  protected readonly warningTypes = WarningMessageType;

  protected closeModal(action: string) {
    this.dialogRef.close(action);
  }
}
